import { EditIcon } from "@root/assets/icons/editIcon";
import DeleteIcon from "@root/assets/icons/delete-02.svg";
import { Flex, Image, Text } from "@chakra-ui/react";
import { DELETE, EDIT } from "@root/constants";
import { useTranslation } from "react-i18next";
import { usersManagementFormatDate } from "@root/utils/helpers";

export const TableColumns = (handleActions: any) => {
  const { t } = useTranslation("common");
  return [
    {
      cell: (info: any) => info?.row?.original?.id || "",
      header: t("superAdminDashboard.userId"),
    },
    {
      cell: (info: any) => info?.row?.original?.name || "",
      header: t("superAdminDashboard.name"),
    },
    {
      cell: (info: any) => info?.row?.original?.email || "N/A",
      header: t("superAdminDashboard.email"),
    },
    {
      cell: (info: any) => info?.row?.original?.slug || "N/A",
      header: t("superAdminDashboard.organizationId"),
    },
    {
      cell: (info: any) =>
        usersManagementFormatDate(info?.row?.original?.updatedAt) || "N/A",
      header: t("superAdminDashboard.lastLogin"),
    },
    {
      cell: (info: any) => (
        <Flex gap={"14px"}>
          <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() => handleActions(EDIT, info?.row?.original)}
          >
            <EditIcon />
          </Flex>
          <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() => handleActions(DELETE, info?.row?.original)}
          >
            <Image src={DeleteIcon} width={18} />
          </Flex>
        </Flex>
      ),
      header: " ",
    },
  ];
};
